/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { invitationAdd } from '../fn/invitation/invitation-add';
import { InvitationAdd$Params } from '../fn/invitation/invitation-add';
import { invitationClicked } from '../fn/invitation/invitation-clicked';
import { InvitationClicked$Params } from '../fn/invitation/invitation-clicked';

@Injectable({ providedIn: 'root' })
export class InvitationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `invitationAdd()` */
  static readonly InvitationAddPath = '/api/Invitation/add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invitationAdd()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  invitationAdd$Response(params?: InvitationAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invitationAdd(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invitationAdd$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  invitationAdd(params?: InvitationAdd$Params, context?: HttpContext): Observable<void> {
    return this.invitationAdd$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `invitationClicked()` */
  static readonly InvitationClickedPath = '/api/Invitation/clicked';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invitationClicked()` instead.
   *
   * This method doesn't expect any request body.
   */
  invitationClicked$Response(params?: InvitationClicked$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invitationClicked(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invitationClicked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invitationClicked(params?: InvitationClicked$Params, context?: HttpContext): Observable<void> {
    return this.invitationClicked$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
